module.exports = __webpack_public_path__ + "00_hair.16609dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/00_hair.png
// module id = n4AJ
// module chunks = 0